import React from 'react';
import './loading.css';

const Loading = () => {
    return (
        <div className='sam__loader-container'>
            <div className='sam__loader-container__kinetic'>
            </div>
        </div>
    )
};

export default Loading;